import { useMemo } from 'react';
// routes
import { paths } from '@src/routes/paths';
// locales
import { useLocales } from '@src/locales';
// components
import SvgColor from '@components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('home.overview'),
        items: [
          {
            title: t('home.dashboard'),
            path: paths.dashboard.root,
            icon: ICONS.dashboard,
          },
          // {
          //   title: t('home.users'),
          //   path: paths.users.root,
          //   icon: ICONS.user
          // },
          {
            title: t('home.doctors'),
            path: paths.doctors.root,
            icon: ICONS.user,
          },
          {
            title: t('home.patients'),
            path: paths.patients.root,
            icon: ICONS.user,
          },
          {
            title: t('home.departments'),
            path: paths.departments.root,
            icon: ICONS.job,
          },
          {
            title: t('home.withdrawals'),
            path: paths.withdrawals.root,
            icon: ICONS.invoice,
          },
          {
            title: t('home.discounts'),
            path: paths.discounts.root,
            icon: ICONS.label,
          },
          {
            title: 'Sanity',
            path: 'https://pet-doctors-365-admin-blog.sanity.studio/structure',
            icon: ICONS.label,
          },
        ],
      },
    ],
    [t]
  );

  return data;
}
